/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import SharingLevel from '@linc-technologies/linced-common/enums/media-sharing-level';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class CategoryDialog extends Component {
  // Services
  @service
  media;

  @service
  session;

  @service
  store;

  @service
  toaster;

  entity = null;
  subject = null;
  isPLP = false;

  @tracked
  label = '';

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  description = '';

  @action
  setDescription(value) {
    this.description = value;
  }

  @tracked
  badgeMediaId = null;

  @tracked
  uploading;

  @tracked
  badgeDescription;

  @action
  setBadgeDescription(value) {
    this.badgeDescription = value;
  }

  @computed('subject.isTopic')
  get typeTitle() {
    if (this.get('subject.isTopic')) {
      return 'Term';
    }
    return 'Goals Category';
  }

  @computed('subject.isTopic')
  get typeLabel() {
    if (this.get('subject.isTopic')) {
      return 'Term';
    }
    return 'Category';
  }

  @computed('subject.isTopic')
  get statesLabel() {
    if (this.get('subject.isTopic')) {
      return 'Term';
    }
    return 'Category Goal';
  }

  // onClose is the action to be performed when closing the dialog.
  onClose() {}

  // onSave is the action to be performed after saving the category.
  onSave() {}

  // getStates is an action that gets all states for goals in this category.
  getStates() {}

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    if (this.entity) {
      this.label = this.entity.label;
      this.description = this.entity.description;
      this.badgeMediaId = this.entity.badgeMediaId;
      this.badgeDescription = this.entity.badgeDescription;
    }
  }

  @action
  closeDialog() {
    this.onClose();
  }

  @action
  getStatesToDelete() {
    this.getStates(...arguments);
  }

  // Category badge image upload handling
  @action
  startUpload() {
    this.uploading = true;
  }

  @action
  handleUpload(file, upload) {
    this.media.handleImageUpload(
      this,
      file,
      upload,
      SharingLevel.PUBLIC,
      this.get('session.school'),
      this.get('session.person'),
      'badgeMediaId',
      'badgeImage',
    );
  }

  @action
  handleUploadError() {
    this.toaster.error('Error uploading badge image!');
  }

  @action
  save() {
    let category = this.entity;

    if (isEmpty(category)) {
      category = this.store.createRecord('goals/category', {
        schoolId: this.get('session.school'),
        subjectId: this.subject,
        isPLP: this.isPLP,
        sequence: this.get('subject.categories.length') + 1,
      });
    }

    category.setProperties({
      label: this.label,
      description: this.description,
      badgeMediaId: this.badgeMediaId,
      badgeDescription: this.badgeDescription,
    });

    category
      .save()
      .then(() => {
        this.onClose();
        this.toaster.success(
          `${this.typeTitle} "${category.get('label')}" saved.`,
        );
      })
      .catch(() => {
        // Unload a new record and revert an edited one; the form keeps the input.
        rollbackRecord(category);
        this.toaster.error(`Error saving ${this.typeTitle}.`);
      })
      .finally(() => {
        this.onSave();
      });
  }
}
